import AuthenticatedLayout from "@shared/layouts/AuthenticatedLayout";
import { useParams } from "react-router-dom";
import { OrganizationProfileCard } from "../components/OrganizationProfileCard";
import { useOrganizationProfile } from "../hooks/useOrganizationProfile";

export default function OrganizationProfile() {
  const { organizationId } = useParams<{ organizationId: string }>();
  const { profile, isLoading, error, refetch } = useOrganizationProfile(
    organizationId,
    {
      staleTime: 0,
      refetchOnWindowFocus: true,
    }
  );

  const handleRefresh = async () => {
    await refetch();
  };

  return (
    <AuthenticatedLayout isLoading={isLoading} error={error}>
      <OrganizationProfileCard profile={profile} onRefresh={handleRefresh} />
    </AuthenticatedLayout>
  );
}
